<template>
  <Dropdown
    ref="select"
    class="category-mode-toggle-airport"
    close-on-click
  >
    <template #trigger="{ toggle }">
      <slot
        name="outer"
        v-bind="{ toggle, ...wrapper }"
      >
        <button
          class="!px-2 w-full btn flex !justify-start"
          type="button"
          :class="{ [activeFilterToggleClass]: currentAirport }"
          @click="toggle"
        >
          <fa
            class="mx-1"
            icon="plane"
          />
          <span class="mx-2">
            {{ currentAirportText }}
          </span>
          <div class="icon-dropdown icon-dropdown-colorless relative ml-auto">
            <fa icon="chevron-down" />
          </div>
        </button>
      </slot>
    </template>
    <template #content="{ toggle }">
      <slot
        name="inner"
        v-bind="{ toggle, ...wrapper }"
      >
        <div class="w-full py-2 bg-white">
          <button
            class="dropdown-item"
            type="button"
            @click="selectAirport(null)"
          >
            {{ $t('allAirports') }}
          </button>
          <button
            v-for="({ name, iata }, i) in airportList"
            :key="i"
            class="dropdown-item"
            type="button"
            @click="selectAirport(iata)"
          >
            <span>
              {{ name }}
            </span>
          </button>
        </div>
      </slot>
    </template>
  </Dropdown>
</template>

<script>
import events from '@layers/web/constants/events.js'

export default defineNuxtComponent({
  props: {
    airports: {
      type: Array,
      default: () => [],
    },

    prefilledAirportIata: {
      type: String,
      default: null,
    },

    activeFilterToggleClass: {
      type: String,
      default: '',
    },
  },

  emits: ['update', events.selectedAirport],

  data () {
    return {
      selectedAirport: null,
    }
  },

  computed: {
    wrapper () {
      return {
        currentAirport: this.currentAirport,
        airports: this.airportList,
        findAirport: this.findAirportByIata,
        select: this.selectAirport,
      }
    },

    currentAirport () {
      return this.findAirportByIata(this.selectedAirport)
    },

    currentAirportText () {
      return this.currentAirport ? this.currentAirport.name : this.$t('allAirports')
    },

    airportList () {
      return this.airports || []
    },
  },

  mounted () {
    if (this.prefilledAirportIata) {
      this.selectedAirport = this.prefilledAirportIata
    }
  },

  methods: {
    hide () {
      this.$refs?.select?.hide()
    },

    findAirportByIata (searchIata) {
      return this.airports.find(({ iata }) => iata === searchIata)
    },

    selectAirport (value) {
      this.selectedAirport = value
      this.$emit('update', value)
      this.$event.$emit(events.selectedAirport, value)
    },
  },
})
</script>
